<div class="wrapper__form container mt-5 mb-3 border__form">
    <div class="row">
        <div class="d-flex flex-row align-items-start">
            <img src="../../../../assets/img/file-alt.svg" alt="logo" class="img-ico-form" />
            <h2 class="mb-0"> 
                {{ nombreCompleto }} 
            </h2>
        </div>
    </div>
    <!--Formulario inicial-->
    <div style="margin-bottom: 4rem !important;">
        <app-form
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['tipo_solicitante']"
            [fields]="tipoSolicitante"
            (changedControl)="onSubmitTipoSolicitante($event)"
            [withSubmitButton]="false">
        </app-form>
    </div>
    <div id="sociedades" *ngIf="formTipoSolicitante.get('tipoSolicitante')?.value === 'SOCIEDAD'">
        <app-roi-sociedad
        [nombreTipoSolicitante]="'SOCIEDAD'"
        [idTipoSolicitante]="getIdSolicitante('SOCIEDAD')"
        [paises]="paises"
        [listaTiposDocumento]="listaTiposDocumento"
        [tramiteRoi]="tramiteRoi"
        (formSociedadOutput)="getFormSociedad($event)">
        </app-roi-sociedad>
    </div>
    <div id="sucursales" *ngIf="formTipoSolicitante.get('tipoSolicitante')?.value === 'SUC_EXTRANJERA'">
        <app-roi-sucursales
        [nombreTipoSolicitante]="'SUC_EXTRANJERA'"
        [idTipoSolicitante]="getIdSolicitante('SUC_EXTRANJERA')"
        [paises]="paises"
        [listaTiposDocumento]="listaTiposDocumento"
        [tramiteRoi]="tramiteRoi"
        (formSucursalOutput)="getFormSucursal($event)">
        </app-roi-sucursales>
    </div>
    <div id="persona-comerciante" *ngIf="formTipoSolicitante.get('tipoSolicitante')?.value === 'PNC'">
        <app-roi-persona-comerciante
        [nombreTipoSolicitante]="'PNC'"
        [idTipoSolicitante]="getIdSolicitante('PNC')"
        [paises]="paises"
        [listaTiposDocumento]="listaTiposDocumento"
        [tramiteRoi]="tramiteRoi"
        (formPnCOutput)="getFormPnC($event)">
        </app-roi-persona-comerciante>
    </div>
    <div id="persona-no-comerciante" *ngIf="formTipoSolicitante.get('tipoSolicitante')?.value === 'PNNC'">
        <app-roi-persona-no-comerciante
        [nombreTipoSolicitante]="'PNNC'"
        [idTipoSolicitante]="getIdSolicitante('PNNC')"
        [paises]="paises"
        [listaTiposDocumento]="listaTiposDocumento"
        [tramiteRoi]="tramiteRoi"
        (formPnNCOutput)="getFormPnNC($event)">
        </app-roi-persona-no-comerciante>
    </div>
</div>
